import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';
import { ProfilesEnum } from 'src/app/data/models/enum/profiles.enum';
import { ProfileService } from 'src/app/data/services/profile.service';
import { ImageItem } from '../select-simple-list/model/item-image.interface';

@Component({
  selector: 'app-profile-simple-list',
  templateUrl: './profile-simple-list.component.html',
  styleUrls: ['./profile-simple-list.component.scss'],
})
export class ProfileSimpleListComponent implements OnChanges {
  @Input() initialIdProfiles: string[] = [];
  @Input() excludeProfiles: ProfilesEnum[] = [];

  @Input() selectAllText: string | undefined;
  @Input() hidePhoto: boolean | undefined;

  @Input() hideButtons = false;

  @Output() selectEvent = new EventEmitter<ImageItem[]>();

  initialList: ImageItem[] = [];
  allSelected = false;

  profilesList: ImageItem[] = [];

  constructor(private readonly profileService: ProfileService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!this.selectAllText) {
      this.selectAllText = 'Todos os itens';
    }
    await this.loadProfiles();
    this.filterProfiles();
    this.allSelected =
      this.profilesList.filter((item) => item.isChecked).length ===
      this.profilesList.length;
  }

  private async loadProfiles(): Promise<void> {
    const result = await this.profileService.getAll().toPromise();
    this.profilesList = result.map(
      (profile) =>
        <ImageItem>{
          id: profile.id,
          imageUrl: '',
          name: profile.name,
          isChecked: this.initialIdProfiles.includes(profile.id!),
        }
    );
  }

  private filterProfiles() {
    var filteredProfiles: string[] = [];
    Object.values(ProfilesEnum).forEach((profile) => {
      if (!this.excludeProfiles.includes(profile))
        filteredProfiles.push(profile.toString());
    });
    this.profilesList = this.profilesList.filter((p) =>
      filteredProfiles.includes(p.name)
    );
  }

  handleEvent(evt: MatSelectionListChange) {
    evt.options
      .map((o) => o.value)
      .forEach((node) => {
        if (typeof node === 'boolean') {
          this.allSelected = !this.allSelected;
          this.selectDeselectAll();
        } else {
          const item = this.profilesList.find(
            (item) => item.id == node.id
          ) as ImageItem;
          item.isChecked = evt.options[0].selected;
          this.allSelected = this.isAllSelected();
        }
      });
    if (this.hideButtons) {
      this.emitEvent();
    }
  }
  private isAllSelected(): boolean {
    return this.profilesList.every((item) => item.isChecked);
  }

  private emitEvent() {
    this.selectEvent.emit(this.profilesList);
  }

  selectDeselectAll(): void {
    this.profilesList.forEach((item) => {
      item.isChecked = this.allSelected;
    });
    if (this.hideButtons) {
      this.emitEvent();
    }
  }

  resetSelection() {
    this.allSelected = false;
    this.selectDeselectAll();
  }

  applySelection() {
    this.emitEvent();
  }

  selectAllClicked() {
    this.allSelected = !this.allSelected;
    this.selectDeselectAll();
  }

  get isPartiallySelected(): boolean {
    return (
      this.profilesList.some((item) => item.isChecked) && !this.isAllSelected()
    );
  }
}
